/**
 * Utility functions for EngagementLetterTemplateSelector
 */

import { WizardComponentBaseProps } from "../../../../reusable_components/WizardPageController/WizardPageController.utils";
import { EngagementLetterWizardSharedData } from "../../CreateEngagementLetterWizard.utils";

export interface TemplateOption {
  label: string;
  value: number;
  filename: string;
  checked?: boolean;
  CreatedBy?: string;
  recipients: string;
  bulkUpload: string;
}

export interface EngagementLetterTemplateSelectorProps extends WizardComponentBaseProps<EngagementLetterWizardSharedData> {}

interface TemplateList {
  TemplateOriginalFileName?: string;
  TemplateId: number;
  FileName: string;
  Recipients: string;
  BulkUpload: string;
}

/**
 * Removes the file extension from a given filename string.
 * @param filename - The filename from which to remove the extension (e.g. `.docx`, `.pdf`)
 * @returns The filename without its extension
 */
export const removeFileExtension = (filename: string): string => {
  return filename.replace(/\.[^/.]+$/, "");
};

/**
 * Converts a list of raw template objects into dropdown-friendly options.
 * @param templates - The list of templates fetched from the API
 * @returns Array of formatted template options with labels and values
 */
export const createTemplateOptions = (templates: TemplateList[]): TemplateOption[] => {
  return templates.map((template) => ({
    label: removeFileExtension(template.TemplateOriginalFileName ?? ""),
    value: template.TemplateId,
    filename: template.FileName,
    recipients: template.Recipients,
    checked: false,
    bulkUpload: template.BulkUpload
  }));
};
